import React from "react"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import PayslipesTable from "./PayslipesTable"
import { useTranslation } from "react-i18next"

export default function PayslipesList() {

  const { t } = useTranslation()
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Payslipes")} />
        <PayslipesTable />
      </div>
    </div>
  )
}
